import { getChapterEntity } from "selectors/chapter/makeGetChapterEntity";

const getIsSubchapter = (state, ownProps) => {
  if (!ownProps.chapterId) {
    return false;
  }

  const chapterEntity = getChapterEntity(state, ownProps);
  if (!chapterEntity) return false;
  return !!chapterEntity.parent;
};

export default getIsSubchapter;
